import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {
  FetchListOrgCanSellProductRequest,
  IContentOrg,
  fetchListOrgCanSellProductApi,
} from 'api/productApi'
import {RootState} from 'store'

export const handleGetListOrgCanSellProduct = createAsyncThunk(
  'orgLicense/getListOrgCanRegister',
  async (payload: FetchListOrgCanSellProductRequest, {rejectWithValue}) => {
    try {
      const response = await fetchListOrgCanSellProductApi(payload)
      return response
    } catch (err) {
      return rejectWithValue(err.message)
    }
  },
)
interface OrgCanRegisterParam {
  page?: number
  size?: number
  orgName?: string
  email?: string
}

interface OrgCanRegisterState {
  loading: boolean
  error: unknown
  query: OrgCanRegisterParam
  listOrgCanRegister: IContentOrg[] | []
  totalPages: number
}

const initialState: OrgCanRegisterState = {
  loading: false,
  error: undefined,
  query: {
    page: 0,
    size: 10,
    orgName: '',
    email: '',
  },
  listOrgCanRegister: [],
  totalPages: 0,
}

export const orgLicenseRegisterSlice = createSlice({
  name: 'orgLicenseRegister',
  initialState,
  reducers: {
    changeQuerySearch: <K extends keyof OrgCanRegisterParam>(
      state: OrgCanRegisterState,
      action: PayloadAction<{key: K; value: OrgCanRegisterParam[K]}>,
    ) => {
      state.query[action.payload.key] = action.payload.value
    },
    resetQuery: (state) => {
      state.query = {...initialState.query}
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(handleGetListOrgCanSellProduct.pending, (state) => {
        state.loading = true
      })
      .addCase(handleGetListOrgCanSellProduct.fulfilled, (state, action) => {
        state.loading = false
        state.listOrgCanRegister = action.payload.page.content
        state.totalPages = action.payload.page.totalPages
      })
      .addCase(handleGetListOrgCanSellProduct.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export const {changeQuerySearch, resetQuery} = orgLicenseRegisterSlice.actions

export default orgLicenseRegisterSlice.reducer

export const selectLoading = (state: RootState) =>
  state.orgLicenseRegister.loading
export const selectQuery = (state: RootState) => ({
  page: state.orgLicenseRegister.query.page,
  size: state.orgLicenseRegister.query.size,
  orgName: state.orgLicenseRegister.query.orgName,
  email: state.orgLicenseRegister.query.email,
})
export const selectError = (state: RootState) => state.orgLicenseRegister.error
export const selectTotalPages = (state: RootState) =>
  state.orgLicenseRegister.totalPages

export const selectListOrgCanRegister = (state: RootState) =>
  state.orgLicenseRegister.listOrgCanRegister
